import { Logger } from "../Logger";
export class ActionsBase {
    handleError(error, callback) {
        Logger.error(error);
        ActionsBase.callbacksError.forEach((callback) => callback(error));
        if (callback) {
            const response = error.response ? JSON.parse(error.response) : { message: 'Internal Error' };
            callback(response);
        }
    }
}
ActionsBase.callbacksError = [];
ActionsBase.addCallback = (callback) => {
    ActionsBase.callbacksError.push(callback);
};
//# sourceMappingURL=ActionsBase.js.map